import axios, { AxiosResponse } from 'axios';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/reducers/type';
import { Auth } from 'commons/constants/KeyFlowConstants';

import qs from 'qs';
import { ReasonPhrases, StatusCodes, getReasonPhrase, getStatusCode } from 'http-status-codes';

import { API_URL } from 'commons/constants/KeyFlowConstants';
import { FAILED_REQUEST_ERROR, NETWORK_ERROR } from 'commons/constants/KeyFlowMessage';
import { KeyFlowMessageType } from 'commons/constants/type';
import KeyFlowError from 'commons/framework/KeyFlowError';
import KeyFlowResponse from './KeyFlowResponse';

export const apiCall = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  paramsSerializer: function (params: any) {
    return qs.stringify(params, { arrayFormat: 'comma' });
  },
});

apiCall.interceptors.response.use(
  function (response) {
    // 응답 데이터를 가공
    if (response.data.success === 'NO') {
      throw new Error(response.data.message);
    }
    return response;
  },
  function (error) {
    // 오류 응답을 처리
    let errorParam: KeyFlowMessageType;
    let httpStatus: StatusCodes = StatusCodes.SERVICE_UNAVAILABLE;

    if (error.response) {
      const { status, data } = error.response;
      const { code, message } = data;

      // 401 에러 발생 시 로컬 스토리지에서 정보 제거
      if (status === StatusCodes.UNAUTHORIZED) {
        localStorage.removeItem(Auth.ACCESS_TOKEN);
        localStorage.removeItem(Auth.USER_ID);
        localStorage.removeItem(Auth.USER_NAME);
      }

      httpStatus = status;
      errorParam = {
        code,
        name: FAILED_REQUEST_ERROR.name,
        korMessage: message,
        engMessage: FAILED_REQUEST_ERROR.engMessage,
      };
    } else {
      errorParam = {
        code: NETWORK_ERROR.code,
        name: NETWORK_ERROR.name,
        korMessage: NETWORK_ERROR.korMessage,
        engMessage: NETWORK_ERROR.engMessage,
      };
    }

    return Promise.reject(new KeyFlowError(errorParam, httpStatus));
  },
);

export function authAPI(
  api: string,
  authParam: { userId: string; userPassword: string },
): Promise<AxiosResponse> {
  const formParam = qs.stringify({
    userId: authParam.userId,
    userPassword: authParam.userPassword,
  });
  return apiCall.post(api, formParam);
}

// data type : param
export function getAPI(api: string, params?: object): Promise<AxiosResponse> {
  return apiCall({
    method: 'GET',
    url: api,
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(Auth.ACCESS_TOKEN)}`,
    },
  });
}

export function getImageAPI(api: string): Promise<AxiosResponse<Blob>> {
  return apiCall({
    method: 'GET',
    url: api,
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem(Auth.ACCESS_TOKEN)}`,
    },
  });
}

export function loginAPI(api: string, params?: object): Promise<AxiosResponse> {
  return apiCall.post(api, params);
}

// data type : body
export function postAPI(api: string, params?: object): Promise<AxiosResponse> {
  return apiCall({
    method: 'POST',
    url: api,
    data: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(Auth.ACCESS_TOKEN)}`,
    },
  });
}

export function putAPI(api: string, params?: object): Promise<AxiosResponse> {
  return apiCall({
    method: 'PUT',
    url: api,
    // data: { data: params },
    data: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(Auth.ACCESS_TOKEN)}`,
    },
  });
}
